import React from "react";
import { Box, Chip, List, ListItem, ListItemText, Typography } from "@material-ui/core";
import { TIPOS_RESPUESTA } from "../helper"; // respeta tu import real

export default function DetallePregunta({ q, respuestas }) {
  if (!q)
    return (
      <Typography color="textSecondary">
        Selecciona una pregunta para ver su detalle
      </Typography>
    );

  const tipo =
    TIPOS_RESPUESTA.find((t) => String(t.value) === String(q.valora))?.label ?? "—";

  const formatTitulo = (pregunta) => {
    if (String(pregunta?.valora) === "3") return pregunta?.nombre ?? "";
    const n = Number(pregunta?.valorb);
    if (Number.isFinite(n)) return `${n}. ${pregunta?.nombre ?? ""}`;
    return pregunta?.nombre ?? "";
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Detalle de la pregunta
      </Typography>
      <Typography variant="subtitle1">{formatTitulo(q)}</Typography>

      <Box mt={2}>
        <Chip label={`Tipo de respuesta: ${tipo}`} size="medium" />
      </Box>

      {q.valora !== "1" && (
        <Box mt={2}>
          <Typography variant="subtitle2">Respuestas</Typography>
          {Array.isArray(respuestas) && respuestas.length > 0 ? (
            <List dense>
              {respuestas.map((r, idx) => (
                <ListItem key={r.id ?? idx}>
                  <ListItemText primary={r?.secundario?.nombre ?? "—"} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography color="textSecondary">Sin respuestas aún.</Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
